import { jsx, Fragment } from 'react/jsx-runtime';
import { useUserSignedIn } from '../useUserSignedIn.js';
import { renderConditionally } from '@sketch/utils';

const IsNotSignedIn = ({ children }) => (jsx(Fragment, { children: renderConditionally(children, !useUserSignedIn()) }));
const IsSignedIn = ({ children }) => (jsx(Fragment, { children: renderConditionally(children, useUserSignedIn()) }));

export { IsNotSignedIn, IsSignedIn };
